import React from 'react'

import { BooleanCell } from '_/components/datagrid/boolean-cell'

export const AreasOfActivityColumns = () => [
  {
    field: 'name',
    headerName: 'Nome',
    sortable: true,
    flex: 1,
    editable: false,
  },
  {
    field: 'active',
    headerName: 'Ativo',
    sortable: true,
    editable: false,
    width: 200,
    renderCell: ({ value }) => <BooleanCell value={value} />,
  },
]
